module.exports = __webpack_public_path__ + "static/media/headshot_600.feedfb6a.png";